import { Tooltip } from "antd";
import type { LineChartSeries } from "../types/dashboard.types";

interface LineChartProps {
	data: LineChartSeries;
	onPointClick?: (label: string) => void;
}

export function LineChart({ data, onPointClick }: LineChartProps) {
	const all = [...data.collected, ...data.plan];
	const max = Math.max(...all) * 1.15;
	const x = (index: number) => 24 + index * ((520 - 48) / (data.labels.length - 1));
	const y = (value: number) => 166 - (value / max) * 142;
	const collectedPoints = data.collected.map((item, index) => `${x(index)},${y(item)}`).join(" ");
	const planPoints = data.plan.map((item, index) => `${x(index)},${y(item)}`).join(" ");
	const areaPoints = `${x(0)},166 ${collectedPoints} ${x(data.labels.length - 1)},166`;

	return (
		<svg className="crm-line-chart" viewBox="0 0 520 190" role="img" aria-label="Oylik dinamika">
			{[0, 1, 2, 3].map((line) => {
				const gridY = 24 + line * ((190 - 48) / 3);
				return <line key={line} x1="24" x2="496" y1={gridY} y2={gridY} />;
			})}
			<polygon points={areaPoints} />
			<polyline className="primary" points={collectedPoints} />
			<polyline className="muted" points={planPoints} />
			{data.labels.map((item, index) => (
				<Tooltip
					key={item}
					title={`Yig'ilgan: ${data.collected[index]}\nReja: ${data.plan[index]}`}
				>
					<g
						style={{ cursor: onPointClick ? "pointer" : "default" }}
						onClick={(e) => {
							e.stopPropagation();
							onPointClick?.(item);
						}}
					>
						<circle
							className="primary-dot"
							cx={x(index)}
							cy={y(data.collected[index])}
							r="5"
							style={{ transition: "r 0.2s" }}
							onMouseEnter={(e) => e.currentTarget.setAttribute("r", "7")}
							onMouseLeave={(e) => e.currentTarget.setAttribute("r", "5")}
						/>
						<circle cx={x(index)} cy={y(data.plan[index])} r="4" fill="#cbd5e1" />
						<text textAnchor="middle" x={x(index)} y="184">
							{item}
						</text>
					</g>
				</Tooltip>
			))}
		</svg>
	);
}
